import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useUserData } from '../hooks/useUserData';
import { Spinner, Center } from '@chakra-ui/react';

interface Props {
  children: ReactNode;
  requireAdmin?: boolean;
}

const PrivateRoute = ({ children, requireAdmin = false }: Props) => {
  const { currentUser } = useAuth();
  const { userData, loading } = useUserData();

  // First check if user is logged in
  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  // For admin routes, check if user is admin
  if (requireAdmin || window.location.pathname.startsWith('/admin')) {
    // Show loading spinner while checking admin status
    if (loading) {
      return (
        <Center h="100vh">
          <Spinner size="xl" />
        </Center>
      );
    }

    // Redirect if not admin
    if (!userData?.isAdmin) {
      return <Navigate to="/" />;
    }
  }

  return <>{children}</>;
};

export default PrivateRoute; 